<admin-app-header></admin-app-header>

<div class="audit-page">
    <div class="container-fluid">
        <div class="page-header">
            <div>
                <h1><i class="fa-solid fa-clipboard-check"></i> Admin Access Audit</h1>
                <p class="page-subtitle">Annual audit of all users with privileged access to the platform.</p>
            </div>
            <button class="btn btn-secondary" (click)="loadAuditData()" [disabled]="loading">
                <i class="fa-solid fa-arrows-rotate" [class.fa-spin]="loading"></i> Refresh
            </button>
        </div>

        <div class="loading-state" *ngIf="loading">
            <i class="fa-solid fa-spinner fa-spin"></i>
            <p>Loading access data...</p>
        </div>

        <div *ngIf="!loading">
            <div class="audit-meta">
                <span><i class="fa-solid fa-clock"></i> Report generated: {{ generatedAt | date: 'dd MMM yyyy, HH:mm' }}</span>
                <span><i class="fa-solid fa-users"></i> Total privileged users: {{ auditUsers.length }}</span>
            </div>

            <div class="section-card">
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th>Enterprise</th>
                            <th>Status</th>
                            <th>UID</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of auditUsers; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td><span class="user-name">{{ user.name }}</span></td>
                            <td><span class="user-email">{{ user.email }}</span></td>
                            <td>
                                <span class="role-badge" [ngClass]="{
                                    'role-admin': user.role === 'Administrator',
                                    'role-sales': user.role === 'Sales Manager',
                                    'role-enterprise': user.role === 'Enterprise Manager'
                                }">{{ user.role }}</span>
                            </td>
                            <td>{{ user.enterpriseKey || '-' }}</td>
                            <td>
                                <span class="status-badge" [ngClass]="user.active ? 'status-active' : 'status-inactive'">
                                    {{ user.active ? 'Active' : 'Inactive' }}
                                </span>
                            </td>
                            <td><code class="uid-code">{{ user.uid }}</code></td>
                        </tr>
                    </tbody>
                </table>

                <div class="empty-state" *ngIf="auditUsers.length === 0">
                    <i class="fa-solid fa-user-slash"></i>
                    <p>No privileged users found.</p>
                </div>
            </div>
        </div>
    </div>
</div>
